package one.healthium.ui

import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import coil3.compose.AsyncImage
import coil3.compose.AsyncImagePainter

@Composable
fun NetworkImage(
    imageUrl: String,
    modifier: Modifier = Modifier,
    contentScale: ContentScale = ContentScale.Fit,
    alignment: Alignment = Alignment.Center,
    onLoaded: () -> Unit = {},
) {
    AsyncImage(
        model = imageUrl,
        modifier = modifier,
        contentScale = contentScale,
        contentDescription = null,
        alignment = alignment,
        onState = {
            if (it is AsyncImagePainter.State.Success) {
                onLoaded()
            }
        }
    )
}